export default {"src":"/_next/static/media/cremebrulee.0f04f12e.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};